import { getAnalyticsTaskHistoryMetric as getDiagramAnalyticsTaskMetric } from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskMetricProps = {
    Metric?: string;
}

export const getAnalyticsTaskHistoryMetric = (): TaskMetricProps => getDiagramAnalyticsTaskMetric();
